import _ from 'lodash'
import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * ProductionLot add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminProductionLotForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminProductionLotFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminProductionLotForm}.
 *
 * @type {ngController}
 */
export class tmrAdminProductionLotFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    Place,
    ProductionWorkflow
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, { Place, ProductionWorkflow })
  }

  $onInit() {
    super.$onInit()
    this.workflows = []
    if (this.resource.id)
      this.resource.$promise
        .then(
          () =>
            this.ProductionWorkflow.query({
              'worker.id': this.resource.place.id,
            }).$promise
        )
        .then(workflows => (this.workflows = workflows))
  }

  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }

  getWorkflows(value) {
    return value
      ? this.workflows.filter(({ name }) => _.iIncludes(name, value))
      : this.workflows
  }

  placeChanged(place) {
    this.workflows.length = 0
    if (place)
      this.workflows = this.ProductionWorkflow.query({ 'worker.id': place.id })
  }
}
